import { Component, ElementRef, Inject, input, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import { AbcConfigService } from '@barthauer/abc/core/configuration';
import {
  DxChatComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { MessageEnteredEvent } from 'devextreme/ui/chat';
import { Subject, takeUntil } from 'rxjs';
import { AbcChatManager } from './abc-chat-manager';

@Component({
  selector: 'abc-chat',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class AbcChatComponent extends DxChatComponent {
  public useDefaultConfig = input(true);

  private chatManager: AbcChatManager;
  private destroy$ = new Subject<void>();

  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private configService: AbcConfigService,
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
  }
  override ngOnInit(): void {
    super.ngOnInit();

    if (this.useDefaultConfig()) {
      this.init();
      this.chatManager = new AbcChatManager(this.configService);
      this.dataSource = this.chatManager.dataSource;
      this.onMessageEntered.subscribe((e) => {
        this.enterMessage(e);
      });
      //handle typing notifications
      this.chatManager.typingUsers$.pipe(takeUntil(this.destroy$)).subscribe((tu) => (this.typingUsers = tu));
    }
  }
  override ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async enterMessage(e: MessageEnteredEvent) {
    await this.chatManager.onMessageEntered(e);
  }

  private init() {
    this.reloadOnChange = false;
  }
}
